import React from 'react'
import {
    BrowserRouter as Router, Routes, Route, Outlet, Navigate
} from "react-router-dom";

import ErrorPage from "../../pages/ErrorPage";
import Navigation from '../Navigation';
import Redeem from '../../pages/Redeem';
import Voucher from '../../pages/Voucher';
import History from '../../pages/History';
import Transaction from '../../pages/Transaction';
import Merchant from '../../pages/Merchant';
import MerchantDetail from '../../pages/MerchantDetail';
import Footer from '../Footer';
import RunningText from '../../pages/RunningText';
import MainLayout from '../../layout/MainLayout';
import FreeLayout from '../../layout/FreeLayout';
import { ThemeProvider } from '../../context/ThemeContext';
import { StoreProvider } from '../../context/StoreContext';
import Profile from '../../pages/Profile';
import ProfileAddressForm from '../../pages/ProfileAddressForm';
import Login from '../../pages/Login';
import Logout from '../../pages/Logout';
import Partner from '../../pages/Partner';
import Product from '../../pages/Product';
import ProductDetail from '../../pages/ProductDetail';
import Order from '../../pages/Order'
import OrderResult from '../../pages/OrderResult';
import TransactionList from '../../pages/TransactionList';
import TransactionDetail from '../../pages/TransactionDetail';
import Balance from '../../pages/Balance';
import Withdrawal from '../../pages/Withdrawal';
import WithdrawalForm from '../../pages/WithdrawalForm';
import WithdrawalDetail from '../../pages/WithdrawalDetail';

const RootRouter = () => {
    
    return (
        <>
            <Router>
                <ThemeProvider>
                <StoreProvider>
                <Routes>
                    <Route path='/' element={<MainLayout />}>
                        <Route index element={<Product/>} />
                        <Route path='/history' element={<History />} />
                        <Route path='/redeem' element={<Redeem />} />
                        <Route path='/voucher' element={<Voucher />} />
                        <Route path='/transaction' element={<Transaction />} />
                        <Route path='/transaction/list' element={<TransactionList />} />
                        <Route path='/transaction/detail/:transactionIdentifier' element={<TransactionDetail />} />
                        <Route path='/merchant' element={<Merchant />} />
                        <Route path='/product' element={<Product />} />
                        <Route path='/product/:item_slug' element={<ProductDetail />} />
                        <Route path='/cart' element={<Navigate to='/product' replace />} />
                        <Route path='/order' element={<Order />} />
                        <Route path='/order/preorder' element={<Navigate to='/order' replace />} />
                        <Route path='/order/status/:status' element={<OrderResult />} />


                        <Route path='/merchant/:id' element={<MerchantDetail />} />
                        <Route path='/profile/address/new' element={<ProfileAddressForm />} />
                        <Route path='/profile/address/:addressId/edit' element={<ProfileAddressForm />} />
                        <Route path='/profile' element={<Profile />} />
                        <Route path='/balance' element={<Balance />} />
                        <Route path='/withdrawal' element={<Withdrawal />} />
                        <Route path='/withdrawal/new' element={<WithdrawalForm />} />
                        <Route path='/withdrawal/:withdrawalId' element={<WithdrawalDetail />} />
                        <Route path='*' element={<ErrorPage />} />
                        <Route path='/404' element={<ErrorPage />} />
                    </Route>

                    <Route path='/auth' element={<FreeLayout/>}>
                        <Route path='login' element={<Login/>}/>
                        <Route path='logout' element={<Logout/>}/>
                        <Route path='partner/:cid/:sid/:lid' element={<Partner/>}/>
                    </Route>
                </Routes>
                </StoreProvider>
                </ThemeProvider>
                
            </Router>

            
        </>

    )

}


export default RootRouter

